/** Shared breakpoints — 4-tier responsive system */
export const BREAKPOINTS = {
  /** < 480px — phones portrait */
  phone: 480,
  /** 480–767px — phones landscape / small devices */
  mobile: 768,
  /** 768–1023px — tablets */
  tablet: 1024,
  /** 1024–1439px — laptops / small desktop */
  desktop: 1440,
  /** ≥ 1440px — large desktop / TV */
  // largeDesktop: no upper limit
  /** Legacy alias — kept for backward compat */
  layoutDesktop: 1280,
};

export function pickBreakpoint(width, { mobile, tablet, desktop }) {
  if (width < BREAKPOINTS.mobile) return mobile;
  if (width < BREAKPOINTS.layoutDesktop) return tablet ?? desktop;
  return desktop;
}

/** CSS grid-template-columns: repeat(N, minmax(0, 1fr)) */
export function gridColumns(width, mobile, tablet, desktop) {
  const n = pickBreakpoint(width, { mobile, tablet, desktop });
  return `repeat(${n}, minmax(0, 1fr))`;
}

/** Returns tier string for current width */
export function getScreenTier(width) {
  if (width < BREAKPOINTS.phone) return 'xs';
  if (width < BREAKPOINTS.mobile) return 'sm';
  if (width < BREAKPOINTS.tablet) return 'md';
  if (width < BREAKPOINTS.desktop) return 'lg';
  return 'xl';
}
